import '../vendor/tagging.min';

export default class Tags {
  constructor() {
    this.$scrollWrap = $('.item-wrap');
  }

  tag() {
    $('#tagBox').tagging({
      'no-duplicate': true,
      'tags-input-name': 'taggone',
      'edit-on-delete': false,
      'forbidden-chars': [',', '?'],
    });
  }

  init() {
    this.tag();
  }
}
